import React, { useState } from 'react';
import { helpCategories, getTopicsByCategory, searchTopics, HelpTopic } from '../data/helpContent';
import styles from '../styles/helpSystem.module.css';

interface HelpDirectoryProps {
  onTopicSelect: (topicId: string) => void;
  onStartTour: () => void;
}

const HelpDirectory: React.FC<HelpDirectoryProps> = ({ onTopicSelect, onStartTour }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState<HelpTopic[]>([]);

  const handleSearch = (query: string) => {
    setSearchQuery(query);
    if (query.trim().length > 0) {
      const results = searchTopics(query);
      setSearchResults(results);
    } else {
      setSearchResults([]);
    }
  };

  const isSearching = searchQuery.trim().length > 0;

  return (
    <div className={styles.directory}>
      <div className={styles.directoryHeader}>
        <h2 className={styles.directoryTitle}>Help & Tour Directory</h2>
        <button className={styles.startTourButton} onClick={onStartTour}>
          🎓 Start Guided Tour
        </button>
      </div>

      <div className={styles.searchSection}>
        <input
          type="text"
          className={styles.searchInput}
          placeholder="🔍 Search help topics..."
          value={searchQuery}
          onChange={(e) => handleSearch(e.target.value)}
        />
      </div>

      {isSearching ? (
        <div className={styles.searchResults}>
          <h3 className={styles.resultsHeader}>
            Search Results ({searchResults.length})
          </h3>
          {searchResults.length === 0 ? (
            <p className={styles.noResults}>No topics found matching "{searchQuery}"</p>
          ) : (
            <div className={styles.resultsList}>
              {searchResults.map(topic => (
                <button
                  key={topic.id}
                  className={styles.searchResultItem}
                  onClick={() => onTopicSelect(topic.id)}
                >
                  <div className={styles.resultContent}>
                    <div className={styles.resultTitle}>{topic.title}</div>
                    <div className={styles.resultDescription}>{topic.description}</div>
                  </div>
                </button>
              ))}
            </div>
          )}
        </div>
      ) : (
        <div className={styles.categoriesList}>
          {helpCategories.map(category => {
            const topics = getTopicsByCategory(category.id);
            
            return (
              <div key={category.id} className={styles.categorySection}>
                <h3 className={styles.categoryTitle}>
                  <span className={styles.categoryIcon}>{category.icon}</span>
                  {category.name}
                </h3>
                <p className={styles.categoryDescription}>{category.description}</p>
                <div className={styles.topicsList}>
                  {topics.map(topic => (
                    <button
                      key={topic.id}
                      className={styles.topicItem}
                      onClick={() => onTopicSelect(topic.id)}
                    >
                      <span className={styles.topicItemTitle}>{topic.title}</span>
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default HelpDirectory;

